import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { getSuggestedFlag } from "@plansoft-configuration-renderer/framework";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
import { useIcon } from "../Icons/IconProvider";
export function ValueSuggestion({ value, }) {
    const t = useUiTranslator();
    const flag = getSuggestedFlag(value);
    const SuggestedYesIcon = useIcon("ValueSuggestedYesIcon");
    const SuggestedNoIcon = useIcon("ValueSuggestedNoIcon");
    if (flag === "*") {
        return _jsx(Fragment, {});
    }
    return (_jsx(Box, { sx: { mx: 1 }, component: "span", children: flag === "+" ? (_jsx(Tooltip, { title: t("ConfigurationRenderer:ValueSuggestion.recommended", "Recommended"), children: _jsx(SuggestedYesIcon, { color: "success", fontSize: "small" }) })) : (_jsx(Tooltip, { title: t("ConfigurationRenderer:ValueSuggestion.notRecommended", "Not recommended"), children: _jsx(SuggestedNoIcon, { color: "warning", fontSize: "small" }) })) }));
}
//# sourceMappingURL=ValueSuggestion.js.map